import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ObservablePoint, Point, PointData } from 'pixi.js';
import { View } from 'src/graphics/view';
import { IAttendee } from 'src/sync/_api';
import { Account } from 'src/sync/account';
import { Room } from 'src/sync/room';
import { WatchAwareComponent } from '../watch-aware.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ForceViewSyncMessage } from '../messenger-service';

@Component({
    selector: 'users-dialog',
    templateUrl: 'users-dialog.component.html',
    styleUrls: ['./users-dialog.component.scss'],
    standalone: false
})
export class UsersDialogComponent extends WatchAwareComponent {
    public owner!: { id: string, data: IAttendee };
    public users: { id: string, data: IAttendee }[] = [];

    constructor(
        public dialogRef: MatDialogRef<UsersDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        override changeDetectorRef: ChangeDetectorRef,
        private snackbar: MatSnackBar
    ) {
        super(changeDetectorRef);
        this.loadAttendees();
    }

    public ngAfterViewInit() {
        this.track(Room.attendance.watchAll(() => {
            this.loadAttendees();
        }))
    }

    public loadAttendees() {
        const users = Room.attendance.toJSON();
        const keys = Object.keys(users);
        this.users = keys.map(k => ({ id: k, data: users[k] }));
        this.owner = this.users.find(x => x.id == Room.ownerId) as { id: string, data: IAttendee };
    }

    public toggleReferee(userId: string) {
        const user = this.users.find(x => x.id == userId)!.data as IAttendee;
        user.referee = !user.referee;
        Room.attendance.set(userId, user);
        this.loadAttendees();
    }

    public removeUser(userId: string) {
        if (userId === this.owner.id || userId === Account.id) return;
        Room.attendance.delete(userId);
        this.loadAttendees();
    }

    public static open(dialogs: MatDialog) {
        if (Room.ownerId == Account.id) {
            dialogs.open(UsersDialogComponent, {});
        }
    }

    public renderPosition(position: PointData) {
        return `(${View.coerce(position.x)}, ${View.coerce(position.y)})`
    }

    public goThere(id: string) {
        this.loadAttendees();
        const user = this.users.find(x => x.id == id)!.data as IAttendee;
        const previousCenter = View.viewport.center;
        const previousScale = View.viewport.scale;
        View.apply(user.view.position, user.view.scale);

        this.snackbar.open(`Moved your view from (${View.coerce(previousCenter.x)}, ${View.coerce(previousCenter.y)}) to (${View.coerce(View.viewport.center.x)}, ${View.coerce(View.viewport.center.y)}).`, 'Go Back', {
            duration: 5000,
        }).onAction().subscribe(() => {
            View.apply(previousCenter, previousScale);
        });
    }

    public bringHere(event: MouseEvent, id: string) {
        const message = new ForceViewSyncMessage(
            {
                position: { x: View.viewport.center.x, y: View.viewport.center.y },
                scale: View.viewport.scale.x,
            },
            Account.id,
            id,
        );

        Room.sendStateless(message);

        const user = this.users.find(x => x.id == id)!.data as IAttendee;
        this.snackbar.open(`Brought ${user.name} here.`, undefined, {
            duration: 5000,
        });

        event.stopPropagation();
    }
}
